import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'About', href: '#about' },
    { label: 'Portfolio', href: '#portfolio' },
    { label: 'Results', href: '#results' },
    { label: 'Services', href: '#services' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ease-out ${
        isScrolled
          ? 'bg-[#0A0A0A]/90 backdrop-blur-md border-b border-[#D4AF37]/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#"
            className="font-playfair text-xl tracking-[0.3em] text-white hover:text-[#D4AF37] transition-colors duration-500"
          >
            AS
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-12">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="relative text-sm tracking-[0.2em] text-[#A1A1AA] hover:text-white transition-colors duration-500 group"
              >
                {link.label.toUpperCase()}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#D4AF37] transition-all duration-500 group-hover:w-full" />
              </button>
            ))}
          </div>

          {/* CTA Button */}
          <button
            onClick={() => scrollToSection('#contact')}
            className="hidden md:block px-6 py-2.5 border border-[#D4AF37] text-[#D4AF37] text-xs tracking-[0.2em] hover:bg-[#D4AF37] hover:text-[#0A0A0A] transition-all duration-500 hover:shadow-[0_0_20px_rgba(212,175,55,0.3)]"
          >
            WORK WITH ME
          </button>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-20 left-0 right-0 bg-[#0A0A0A]/95 backdrop-blur-md border-b border-[#D4AF37]/10 transition-all duration-500 ${
          isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div className="px-6 py-8 space-y-6">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollToSection(link.href)}
              className="block w-full text-left text-sm tracking-[0.2em] text-[#A1A1AA] hover:text-[#D4AF37] transition-colors duration-300"
            >
              {link.label.toUpperCase()}
            </button>
          ))}
          <button
            onClick={() => scrollToSection('#contact')}
            className="w-full px-6 py-3 border border-[#D4AF37] text-[#D4AF37] text-xs tracking-[0.2em] hover:bg-[#D4AF37] hover:text-[#0A0A0A] transition-all duration-500"
          >
            WORK WITH ME
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
